var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6086 13.881C28.6086 6.21285 22.3957 0 14.7276 0C7.05947 0 0.846619 6.21285 0.846619 13.881C0.846619 20.8091 5.92269 26.5518 12.5587 27.594V17.8936H9.03247V13.881H12.5587V10.8227C12.5587 7.34404 14.6296 5.42253 17.8015 5.42253C19.3206 5.42253 20.9091 5.69344 20.9091 5.69344V9.10771H19.1583C17.4344 9.10771 16.8965 10.1779 16.8965 11.2755V13.881H20.7462L20.1305 17.8936H16.8965V27.594C23.5325 26.5518 28.6086 20.8091 28.6086 13.881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.556ad4d5c3359c16259c67d5b4052dda.svg";
export { ForwardRef as ReactComponent };